<template>
    <div class="registration-succsess__wrapper">
        <SpinnerBars
            v-if="isLoading"
        />
        <div v-else-if="isError">
            {{ $t('There was some problems, please contact our support') }}
        </div>
        <div v-else>
            <div class="notice">
                {{ $t('Your account has been activated! Enjoy your game') }}
            </div>
            <Illustration xl image="/static/img/illustrations/account__activation-success.svg"/>
            <button class="btn btn__primary btn__primary--green btn--block" @click="onChooseBonusClick">
                {{ $t('Choose your bonus before deposit') }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Modals from '@store/modules/ui/shared/modal/modals';
    // import { errorGuard } from '@app/utils';

    export default {
        name: 'ActivateAccountContainer',
        data() {
            return {
                isLoading: true,
                isError: false
            };
        },
        // async created() {
        //     await errorGuard({
        //         action: () => this.activateAccount(this.$router.currentRoute.query.activationCode),
        //         onError: () => {
        //             this.isError = true;
        //             this.showHelp();
        //         },
        //     });
        //     this.isLoading = false;
        // },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            ...mapActions('data/authentication', [
                'activateAccount',
            ]),
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            onChooseBonusClick() {
                this.setModal(Modals.welcomeBonusIntro.code);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/authentication/ActivateAccountContainer.vue